import React, { forwardRef } from 'react'
import styled from '@emotion/styled'

import { Box, BoxProps } from '../Box'

const Wrapper = styled(Box)`
  flex-shrink: 0;
  backface-visibility: hidden;

  &:not(:root) {
    overflow: hidden;
  }
`

export interface SvgProps extends BoxProps {
  role?: string
  focusable?: boolean
  viewBox?: string
}

export const Svg = forwardRef(({ role = 'presentation', ...restProps }: SvgProps, ref) => {
  return <Wrapper as="svg" ref={ref} role={role} {...restProps} />
})

Svg.displayName = 'Svg'

export default Svg
